export default {
  loading: state => state.loading.isVisible,
  snackbarIsVisible: state => state.snackbar.isVisible,
  snackbarMessage: state => state.snackbar.message,
  snackbarCentered: state => state.snackbar.centered,
  snackbarType: state => state.snackbar.type,
};



// WEBPACK FOOTER //
// ./src/store/modules/application/getters.js